import { Card } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { ECustomerModalType } from 'src/enums/ESmartCRM';

interface CustomerTypeSelectionProps {
	onTypeSelect: (type: ECustomerModalType) => void;
}

export const CustomerTypeSelection = ({ onTypeSelect }: CustomerTypeSelectionProps) => {
	return (
		<div className="p-6">
			<h3 className="text-lg font-semibold mb-6 text-center">
				How would you like to add customers?
			</h3>

			<div className="space-y-4">
				<Card
					hoverable
					className="text-center cursor-pointer border-2 hover:border-blue-500"
					onClick={() => onTypeSelect(ECustomerModalType.MANUAL)}
				>
					<div className="p-4">
						<UserOutlined className="text-4xl text-blue-500 mb-4" />
						<h4 className="text-lg font-medium mb-2">Enter Customer Manually</h4>
						<p className="text-gray-600">Fill out the form to add a single customer</p>
					</div>
				</Card>

				{/* <Card
					hoverable
					className="text-center cursor-pointer border-2 hover:border-blue-500"
					onClick={() => onTypeSelect(ECustomerModalType.CSV_UPLOAD)}
				>
					<div className="p-4">
						<UploadOutlined className="text-4xl text-green-500 mb-4" />
						<h4 className="text-lg font-medium mb-2">Upload CSV</h4>
						<p className="text-gray-600">Import multiple customers from a CSV file</p>
					</div>
				</Card> */}
			</div>
		</div>
	);
};
